import React from "react";
import styled from "styled-components";
import Tag from "./Tag";
import { AromaCategory, Aroma } from "@/types";
import { fontFamily } from "@/styles/font";

interface AromaSelectorProps {
    aromaTags: AromaCategory[];
    selectedTags: number[];
    onTagClick: (aromaId: number) => void;
    readOnly?: boolean;
}

const AromaSelector: React.FC<AromaSelectorProps> = ({ aromaTags, selectedTags, onTagClick, readOnly = false }) => {
    // 아로마 카테고리 순서 정의
    const aromaOrder = ["과일", "식물", "곡물", "유제품", "향신료 & 한약재", "기타"];

    // 아로마 카테고리 순서에 따라 정렬
    const sortedAromaTags = aromaOrder
        .map((category) => aromaTags.find((tag) => tag.category === category))
        .filter((category): category is AromaCategory => category !== undefined); // 존재하는 카테고리만 필터링

    return (
        <>
            {sortedAromaTags.map((category) => (
                <TagSection key={category.category}>
                    <TagTitle>{category.category}</TagTitle>
                    <TagList>
                        {category.aromaList.map((aroma: Aroma) => (
                            <Tag
                                key={aroma.id}
                                label={aroma.name}
                                isSelected={selectedTags.includes(aroma.id)}
                                onClick={readOnly ? () => {} : () => onTagClick(aroma.id)}
                            />
                        ))}
                    </TagList>
                </TagSection>
            ))}
        </>
    );
};

const TagSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 9px;
    width: 100%;
    margin-top: 16px;

    &:first-of-type {
        margin-top: 0;
    }
`;

const TagTitle = styled.h3`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #000000;
    margin: 0;
`;

const TagList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    padding: 0px;
    gap: 6px;
    width: 100%;
`;

export default AromaSelector;
